// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Info as RawInfo } from "lucide-react";
export const Info = /* @__PURE__ */ createIcon(RawInfo, "Info", 2);
